import { getDefaultOTELInstrumentations, TracingInstrumentation } from '@grafana/faro-web-tracing';
import { getWebInstrumentations, initializeFaro, InternalLoggerLevel } from '@grafana/faro-web-sdk';
import { ReplayInstrumentation } from '@grafana/faro-instrumentation-replay';

import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';

const {
  NEXT_PUBLIC_FARO_APP_NAME = '',
  NEXT_GRAFANA_FARO_ENDPOINT = '',
} = typeof window !== 'undefined' ? window.ENV : {};

const Faro = async (collectorString: string) => {
  const url = NEXT_GRAFANA_FARO_ENDPOINT || collectorString;

  if (url) {
    initializeFaro({
      beforeSend: item => {
        delete item.meta.k6;

        return item;
      },
      url: NEXT_GRAFANA_FARO_ENDPOINT || collectorString,

      app: {
        name: NEXT_PUBLIC_FARO_APP_NAME,
        version: '1.0.0',
        environment: 'production',
      },
      trackGeolocation: true,

      instrumentations: [
        ...getWebInstrumentations(),

        new ReplayInstrumentation({
          samplingRate: 0.01,
        }),

        new TracingInstrumentation({
          instrumentations: [
            ...getDefaultOTELInstrumentations({
              ignoreUrls: [NEXT_GRAFANA_FARO_ENDPOINT],
            }),
          ],
        }),
      ],
      ignoreErrors: [/Minified React error/i],
    });
  }
};

export default Faro;
